import React from "react";
import Auth from "components/core/Auth/Auth";

const PrivateRoute = ({ children, ...props }) => {
  // check if user is authenticated
  return <Auth>{children}</Auth>;
};

export default PrivateRoute;
